import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  
  <React.StrictMode>
    
    <App />
  </React.StrictMode>
);

// Регистрация сервис-воркера для работы оффлайн и улучшенной производительности
serviceWorkerRegistration.register();

// Опционально, для логирования производительности
reportWebVitals();
